import type { MediaPlan } from '@mint-sdk/api-media-plan';

export type FlightItem = NonNullable<
  MediaPlan.FlightsList['data']
>['items'][number];

export const FLIGHT_TOTAL_ROW_ID = 'flight-total-row';
